import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';
import type { ISchedulesState } from '@/store/types';

import { combineSchedulesListToGrouppedSchedulesList } from '@/store/combiners/scheduleCombiners';
import { selectUserTimezone } from '@/store/selectors/authSelectors';
import { getShifts } from '@/store/slices/scheduleSlice';

/**
 * SP
 */
export const selectScheduleColors = (state: RootState): ISchedulesState['scheduleColors'] =>
  state.schedule.scheduleColors;
const emptySchedulesList: ISchedulesState['schedulesList'] = [];
export const selectSchedulesList = (state: RootState): NonNullable<ISchedulesState['schedulesList']> =>
  state.schedule.schedulesList ?? emptySchedulesList;
export const selectIsSchedulesListLoading = (state: RootState): boolean =>
  state.schedule.schedulesList === null || selectIsPendingAction(getShifts.typePrefix)(state);
export const selectSelectedSchedulesIds = (state: RootState): ISchedulesState['selectedSchedulesIds'] =>
  state.schedule.selectedSchedulesIds;
export const selectScheduleIdsToShowDetailsFor = (state: RootState): ISchedulesState['scheduleIdsToShowDetailsFor'] =>
  state.schedule.scheduleIdsToShowDetailsFor;
export const selectSelectedAvailableShifts = (state: RootState): ISchedulesState['selectedAvailableShifts'] =>
  state.schedule.selectedAvailableShifts;
export const selectAvailableShifts = (state: RootState): ISchedulesState['availableShifts'] =>
  state.schedule.availableShifts;
export const selectUpcomingShifts = (state: RootState): ISchedulesState['upcomingShifts'] =>
  state.schedule.upcomingShifts;

/**
 * SU
 */
export const selectClientSchedules = (state: RootState): ISchedulesState['client']['schedules'] =>
  state.schedule.client.schedules;
export const selectClientShifts = (state: RootState): ISchedulesState['client']['shifts'] =>
  state.schedule.client.shifts;
export const selectClientShiftDetails = (state: RootState): ISchedulesState['client']['shiftDetails'] =>
  state.schedule.client.shiftDetails;
export const selectClientSelectedSchedule = (state: RootState): ISchedulesState['client']['selectedSchedule'] =>
  state.schedule.client.selectedSchedule;

export const selectGrouppedSchedulesList = createSelector(
  selectSchedulesList,
  selectUserTimezone,
  combineSchedulesListToGrouppedSchedulesList,
);

/**
 * Meta
 */
export const selectIsPending = (state: RootState): boolean => Boolean(state.schedule.meta.pending.length);
export const selectIsPendingAction =
  (actionType: string) =>
  (state: RootState): boolean =>
    state.schedule.meta.pending.some(action => action === actionType);
